import styles from './index.module.sass';
import Icon from 'components/icon';
import powerby from 'assets/icon_powered-by-Autopass.svg';

const PowerBy = ({ invert }) => {
  return (
    <div className={`${styles.powerBy} ${invert ? styles.invert : ''}`}>
      <Icon imgSrc={powerby} height="14px" alt="logo" />
    </div>
  );
};

export default PowerBy;
